// extracted by mini-css-extract-plugin
export default {"loginCard":"style_loginCard__e4wP8"};